function cardUnmask(str) {
  if (!str) return undefined;
  if (typeof str === 'string' || str instanceof String) {
    return str && str.replace(/[\s]/g, '');
  }
  return str;
}
export default cardUnmask;
